'use client';

import { type CSSProperties, type HTMLProps, useEffect, useState } from 'react';

/**
 * Renders an anchor tag that is then disabled with JS.
 * Meant to be used as a fallback for when JS is unavailable
 */
export const NoJSLink = (props: HTMLProps<HTMLAnchorElement>) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, [isHydrated]);

  const style: CSSProperties = {
    pointerEvents: isHydrated ? 'none' : 'auto',
    ...(props.style ?? {}),
  };

  return <a {...props} style={style} />;
};
